import cloneDeep from 'lodash/fp/cloneDeep'
import {
  PENDING_APPROVAL_START_EDITING_INVESTMENT_MINIMUMS
  , PENDING_APPROVAL_STOP_EDITING_INVESTMENT_MINIMUMS
  , PENDING_APPROVAL_CANCEL_EDITING_INVESTMENT_MINIMUMS
  , PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_LUMP_SUM
  , PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_MONTHLY_DEBIT_ORDER
  , PENDING_APPROVAL_SET_ALLOW_UNSURE_INVESTORS
  , PENDING_APPROVAL_UPDATING_INVESTMENT_MINIMUMS
  , PENDING_APPROVAL_UPDATED_INVESTMENT_MINIMUMS
} from './adviserProfileInvestmentMinimumsEditorActions'
import { validiateMoneyField } from '../../../../../common/forms/validationFunctions'

const initialState = {
  loadingInvestmentMinimums: false,
  editingInvestmentMinimums: false,
  investmentMinimumsBeforeEditing: {},
  updatingInvestmentMinimums: false,
  isInvalid: {
    formIsValid: true,
    minimumLumpSum: {
      isInvalid: false,
      message: null
    },
    minimumMonthlyDebitOrder: {
      isInvalid: false,
      message: null
    }
  }
}

export default function (state = initialState, action) {
  var newState = cloneDeep(state)
  switch (action.type) {
    case PENDING_APPROVAL_UPDATING_INVESTMENT_MINIMUMS:
      newState.investmentMinimums = copyInvestmentMinimumsState(newState)
      newState.investmentMinimums.updatingInvestmentMinimums = true
      return newState
    case PENDING_APPROVAL_UPDATED_INVESTMENT_MINIMUMS:
      newState.investmentMinimums = copyInvestmentMinimumsState(newState)
      newState.investmentMinimums.updatingInvestmentMinimums = false
      return newState
    case PENDING_APPROVAL_START_EDITING_INVESTMENT_MINIMUMS:
      newState.investmentMinimums = copyInvestmentMinimumsState(newState)
      newState.investmentMinimums.editingInvestmentMinimums = true
      newState.investmentMinimumsBeforeEditing = cloneDeep(newState.pendingApprovalProfile.investmentMinimums)
      return newState
    case PENDING_APPROVAL_STOP_EDITING_INVESTMENT_MINIMUMS:
      newState.investmentMinimums = copyInvestmentMinimumsState(newState)
      newState.investmentMinimums.editingInvestmentMinimums = false
      return newState
    case PENDING_APPROVAL_CANCEL_EDITING_INVESTMENT_MINIMUMS:
      newState.investmentMinimums = copyInvestmentMinimumsState(newState)
      newState.investmentMinimums.editingInvestmentMinimums = false
      newState.pendingApprovalProfile.investmentMinimums = cloneDeep(newState.investmentMinimumsBeforeEditing)
      newState.investmentMinimumsBeforeEditing = {}
      return newState
    case PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_LUMP_SUM:
      newState.pendingApprovalProfile.investmentMinimums.minimumLumpSum = action.minimumLumpSum
      newState.investmentMinimums.isInvalid.minimumLumpSum = validiateMoneyField(action.minimumLumpSum, true)
      newState.investmentMinimums.isInvalid.formIsValid = formIsValid(newState.investmentMinimums.isInvalid)
      newState.edited = true
      return newState
    case PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_MONTHLY_DEBIT_ORDER:
      newState.pendingApprovalProfile.investmentMinimums.minimumMonthlyDebitOrder = action.minimumMonthlyDebitOrder
      newState.investmentMinimums.isInvalid.minimumMonthlyDebitOrder = validiateMoneyField(action.minimumMonthlyDebitOrder, true)
      newState.investmentMinimums.isInvalid.formIsValid = formIsValid(newState.investmentMinimums.isInvalid)
      newState.edited = true
      return newState
    case PENDING_APPROVAL_SET_ALLOW_UNSURE_INVESTORS:
      newState.pendingApprovalProfile.investmentMinimums.allowUnsureInvestors = action.allow
      newState.edited = true
  }
  return newState
}

function copyInvestmentMinimumsState (state) {
  var investmentMinimums = cloneDeep(state.investmentMinimums)
  investmentMinimums.isInvalid = cloneDeep(state.investmentMinimums.isInvalid)
  return investmentMinimums
}

function formIsValid (isInvalid) {
  return !isInvalid.minimumLumpSum.isInvalid &&
    !isInvalid.minimumMonthlyDebitOrder.isInvalid
}
